
import { getFormatedCarName } from "../helpers/getFormatedCarname";
import { getFormattedCarNameAllUppercase } from "../helpers/getFormatedCarNameAllUppercase";

export const getFallbackMakeLogoImage = (carMake) => {
    const preparedCarMakeFirstUpper = getFormatedCarName(carMake);
    const preparedCarMakeAllUpper = getFormattedCarNameAllUppercase(carMake);

    const imageExtension = "png";

    const getImage = require.context(
        '../../../SharedComponents/assets/images/car-brand-logos',
        false,
        /\.(png)$/
    );

    try {
        const Image = getImage(`./${preparedCarMakeFirstUpper}.${imageExtension}`);
        return Image;
    } catch (error) {
        try {
            const Image = getImage(`./${preparedCarMakeAllUpper}.${imageExtension}`);
            return Image;
        } catch (error) {
console.error(error);
        }
    }
};
